module.exports = __webpack_public_path__ + "res/img_bg.f2b5582d8dd052f6e52be1ed6f13edf9.png";